// extracted by mini-css-extract-plugin
export default {"Container":"StayTouch_Container__h7Ulj","SubHeading":"StayTouch_SubHeading__anfP2","Normal":"StayTouch_Normal__lLjn2","AboutMe":"StayTouch_AboutMe__HJu0u"};